// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Header-cls1___f9b94f2e0ee8fd363e6{/*!*/}.Header-cls2___65c0eaae78271ae6744{display:flex;flex-direction:column;justify-content:center;min-height:46px;padding-top:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Header-cls1___f9b94f2e0ee8fd363e6",
	"cls2": "Header-cls2___65c0eaae78271ae6744 Header-cls1___f9b94f2e0ee8fd363e6"
};
export default ___CSS_LOADER_EXPORT___;
